
export interface ValidationResult {
    ok: boolean;              // esito complessivo
    error: string;            // motivi dell’eventuale KO
    class?: string;            // classe CSS da applicare
}

export const validate = (elementId: string, validator: (inputElement: HTMLInputElement) => ValidationResult | void) => {
    let theInput = document.getElementById(elementId) as HTMLInputElement;

    if (theInput) {
        let container = theInput.parentElement;
        let feedbackElement = container?.querySelector(".invalid-feedback");
        let result = validator(theInput);

        if (result) {
            theInput.classList.toggle("is-invalid", !result.ok);
            theInput.classList.toggle("is-valid", result.ok);
            theInput.setCustomValidity(result.error);

            if (feedbackElement) {
                if (!result.ok && result.error) {
                    // ✅ Campo non valido: scrive il messaggio e lo mostra
                    feedbackElement.innerHTML = result.error;
                    feedbackElement.classList.remove("d-none");
                } else {
                    // ✅ Campo valido o nessun messaggio: pulisce
                    feedbackElement.innerHTML = "";
                    feedbackElement.classList.add("d-none");
                }
                if (result.class != null) {
                    container!.classList.add(result.class);
                }
            }
        } else {
            resetValidation(elementId);
        }
    }
}


export const resetValidation = (elementId: string) => {
    let theInput = document.getElementById(elementId) as HTMLInputElement;
    if (theInput) {
        let container = theInput.parentElement;
        let feedbackElement = container?.querySelector(".invalid-feedback");

        theInput.classList.toggle("is-invalid", false);
        theInput.classList.toggle("is-valid", false);
        theInput.setCustomValidity("");
        if (feedbackElement) {
            feedbackElement.innerHTML = "";
            feedbackElement.classList.add("d-none");
        }
    }
}

export const setValidatorOnInput = (elementId: string, validator: (inputElement: HTMLInputElement) => ValidationResult | void) => {
    const element = document.getElementById(elementId) as HTMLInputElement;
    if (element) {
        element.addEventListener('input', function (event) {
            validate(elementId, validator);
        }, false);
    }
}

export const setValidatorOn = (eventName: string, elementId: string, validator: (inputElement: HTMLInputElement) => ValidationResult | void) => {
    const element = document.getElementById(elementId) as HTMLInputElement;
    if (element) {
        element.addEventListener(eventName, function (event) {
            validate(elementId, validator);
        }, false);
    }
}

